<ion-list>
  <ion-item  (click)="select('Network')">
    <ion-icon name="globe-outline" slot="start"></ion-icon>
    <ion-label>Network</ion-label>
  </ion-item>
  <ion-item button (click)="select('Bluetooth')">
    <ion-icon name="bluetooth-outline" slot="start"></ion-icon>
    <ion-label>Bluetooth</ion-label>
  </ion-item>
  <ion-item button (click)="select('FlashLight')">
    <ion-icon name="flashlight-outline" slot="start"></ion-icon>
    <ion-label>Flash Light</ion-label>
  </ion-item>
  <ion-item button (click)="select('Dialer')">
    <ion-icon name="call-outline" slot="start"></ion-icon>
    <ion-label>Phone</ion-label>
  </ion-item>
</ion-list>